import React from 'react';
import { ArrowLeftIcon, ArrowRightIcon } from 'radiance-ui/lib/icons';
import { RoundButton } from 'radiance-ui';
import { SPACER } from 'radiance-ui/lib/constants';
import { css } from '@emotion/react';

import CONFIG from 'jsx/constants/config';

interface FormNavigationProps {
  onClickBack?: false | (() => void);
  isSubmitting?: boolean;
  canSubmit?: boolean;
  canNavigateBack?: boolean;
}

const FormNavigation: React.FC<FormNavigationProps> = ({
  onClickBack,
  isSubmitting,
  canSubmit,
  canNavigateBack = true,
}) => (
  <RoundButton.Container
    css={css`
      margin-top: ${SPACER.x2large};
    `}
    multi={!!onClickBack}
  >
    {!!onClickBack && (
      <RoundButton
        buttonType="tertiary"
        icon={<ArrowLeftIcon />}
        disabled={!canNavigateBack}
        onClick={onClickBack}
        data-test-id="nav-prev"
        aria-label="Back"
      />
    )}
    <RoundButton
      buttonType={CONFIG.isAgencyApp ? 'primary' : 'secondary'}
      isLoading={isSubmitting}
      disabled={!canSubmit}
      icon={<ArrowRightIcon />}
      type="submit"
      data-test-id="nav-next"
      aria-label="Next"
    />
  </RoundButton.Container>
);

export default FormNavigation;
